<template>
  <nav class="cbn-nav">
    <button
      type="button"
      class="cbn-item"
      :class="{ active: active === 'home' }"
      @click="onNav('home')"
    >
      <el-icon :size="24"><HomeFilled /></el-icon>
      <span>หน้าหลัก</span>
    </button>
    <button
      type="button"
      class="cbn-item"
      :class="{ active: active === 'history' }"
      @click="onNav('history')"
    >
      <el-icon :size="24"><Memo /></el-icon>
      <span>ประวัติ</span>
    </button>
    <button
      type="button"
      class="cbn-item"
      :class="{ active: active === 'report' }"
      @click="onNav('report')"
    >
      <el-icon :size="24"><DataAnalysis /></el-icon>
      <span>ผลตรวจ</span>
    </button>
    <button
      type="button"
      class="cbn-item"
      :class="{ active: active === 'promotion' }"
      @click="onNav('promotion')"
    >
      <el-icon :size="24"><Discount /></el-icon>
      <span>แพ็คเกจ/โปรโมชั่น</span>
    </button>
    <button
      type="button"
      class="cbn-item"
      :class="{ active: active === 'me' }"
      @click="onNav('me')"
    >
      <el-icon :size="24"><UserFilled /></el-icon>
      <span>โปรไฟล์</span>
    </button>
  </nav>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { HomeFilled, Memo, Discount, UserFilled, DataAnalysis } from "@element-plus/icons-vue";

export type CbnTab = "home" | "history" | "promotion" | "me" | "report" | "receipt";

interface Props {
  active?: CbnTab;
}
const props = defineProps<Props>();

const router = useRouter();
let navigating = false;

function onNav(tab: CbnTab): void {
  if (props.active === tab || navigating) return;
  navigating = true;
  const target = (() => {
    switch (tab) {
      case "home":
        return { name: "customer-home" };
      case "history":
        return { name: "customer-history" };
      case "report":
        return { name: "customer-health-report" };
      case "promotion":
        return { name: "customer-vaccine" };
      case "me":
        return { name: "customer-profile" };
      default:
        return null;
    }
  })();

  if (target) {
    router.push(target).finally(() => {
      navigating = false;
    });
  } else {
    navigating = false;
  }
}
</script>

<style scoped>
.cbn-nav {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #f1f5f9; /* subtle border instead of heavy shadow */
  padding: 8px 2px max(12px, env(safe-area-inset-bottom)) 2px;
  box-sizing: border-box;
}
.cbn-item {
  min-width: 0;
  background: transparent;
  border: none;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 2px;
  font-size: 11px;
  color: #94a3b8; /* slate-400 */
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.12s ease;
}
.cbn-item span {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 10.5px;
  letter-spacing: -0.2px;
  text-align: center;
}
.cbn-item:active {
  background: rgba(59, 130, 246, 0.06);
}
.cbn-item.active {
  color: var(--c-primary);
  font-weight: 600;
}
.cbn-item.active .el-icon {
  transform: scale(1.05);
}
</style>
